/* istanbul ignore file */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-family-welcome-message',
  templateUrl: './family-welcome-message.component.html',
  styleUrls: ['./family-welcome-message.component.scss']
})
export class FamilyWelcomeMessageComponent {
  @Input() contractLastName: string = '';
}
